import { profileState } from './state';

/**
 * Locking the open profile (docs/TZ-PROFILES.md 4.5): by hand, or after the idle time the profile
 * set (5 / 15 / 60 minutes). While locked the PIN screen covers the app and no key reaches it.
 * Only a profile with a PIN can be locked.
 */
let timer: ReturnType<typeof setTimeout> | null = null;
let installed = false;

export function canLock(): boolean {
  return !!profileState.current?.pin && !profileState.guest;
}

export function lockProfile(): void {
  if (canLock()) profileState.locked = true;
}

export function unlockProfile(): void {
  profileState.locked = false;
  restartIdle();
}

/** Start (again) counting idle time from now. */
export function restartIdle(): void {
  if (timer) clearTimeout(timer);
  timer = null;
  const minutes = profileState.current?.lockAfter ?? 0;
  if (!minutes || !canLock() || profileState.locked) return;
  timer = setTimeout(lockProfile, minutes * 60_000);
}

export function installProfileLock(): void {
  if (installed) return;
  installed = true;
  let last = 0;
  const activity = () => {
    // pointer moves come in streams: count them at most once a second
    const now = Date.now();
    if (now - last < 1000) return;
    last = now;
    if (!profileState.locked) restartIdle();
  };
  for (const ev of ['pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart']) window.addEventListener(ev, activity, { passive: true, capture: true });
  // locked: keys reach only the PIN screen, never the canvas or the app's shortcuts
  window.addEventListener(
    'keydown',
    (e) => {
      if (!profileState.locked) return;
      const target = e.target as Element | null;
      if (target?.closest?.('[data-profile-lock]')) return;
      e.stopImmediatePropagation();
      e.preventDefault();
    },
    { capture: true },
  );
  restartIdle();
}
